import "./style.scss";
import domReady from "@wordpress/dom-ready";

function Accordion() {
  const accordions = document.querySelectorAll(".wp-block-intempus-accordion-item");
  if (!accordions.length) return null;

  function toggleAccordian() {
    this.classList.toggle("active");
  }

  accordions.forEach(function (accodian) {
    //console.log("here");
    accodian.addEventListener("click", toggleAccordian);
    if (accodian.getAttribute("data-open")) {
      accodian.classList.toggle("active");
    }
  });
}

domReady(Accordion);
